<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'applicationDate')">
              <a-range-picker
                v-model='queryParam.lendingTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'ProductType')">
              <a-select
                        v-model='queryParam.appSsids'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>

            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'settlementType')">
              <a-select default-value='' style='width: 120px' v-model='queryParam.settleType'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='1'>
                  非逾期结清
                </a-select-option>
                <a-select-option value='2'>
                  逾期结清
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('order.applicationDeadline')">
<!--              <a-select default-value='' style='width: 190px' v-model='queryParam.deadlineConfigValue'>-->
<!--                <a-select-option v-for='item in deadlineConfigList' :key='item.itemValue'>-->
<!--                  {{ item.itemText }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
              <dict-select
                v-model='queryParam.deadlineConfigValue'
                :dict-code='DICT_CODE.Deadline_ConfigValue'
                :begin="[{ value: '', label: '全部', labelEn: 'All',labelTi: 'ทั้งหมด' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>

          <a-col :md='4' :sm='4'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'rateValue')">
              <a-input :placeholder="$t('enter') +' '+ $t(I18N_KEY.ORDER + 'rateValue')"
                       v-model='queryParam.serviceFee'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='5' :sm='5'>
            <a-form-item label="前收后收">
              <a-select default-value="" style="width: 120px" v-model="queryParam.receiptTimeFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  前收
                </a-select-option>
                <a-select-option value="1">
                  后收
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='5' :sm='5'>
            <a-form-item label="运营类型">
              <a-select default-value="" style="width: 120px" v-model="queryParam.proxyFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  自运营
                </a-select-option>
                <a-select-option value="1">
                  代理运营
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='3' :sm='3'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
              <!--<a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">导出</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>


    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :auditDrawer='false'
          @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, reborrowCount, reborrowCountForSubmit } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'reborrowCount',
  components: {
    Dict,
    DictSelect,
    vModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      deadlineConfigList: [],
      appList: [],
      // 查询条件
      queryParam: {
        receiptTimeFlag:'',
        lendingTime:[],
        'deadlineConfigValue':"",
        'appssid': '',
        'serviceFee': null,
        'duration': '',
        'settleType':"",
        'appSsids': ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('order.ActualRepaymentDate'),
          align: 'left',
          dataIndex: 'timeStr'
        },
        {
          title: this.$t('order.applicationsNum'),
          align: 'left',
          dataIndex: 'countSettleOrder'
        },
        {
          title: this.$t('order.ReBorrowOnTheSameDayOfRepay'),
          align: 'left',
          dataIndex: 'curReborrowCount'
        },
        {
          title: this.$t('order.ReBorrowOnThe2DayOfRepay'),
          align: 'left',
          dataIndex: 'reborrowCount2'
        },
        {
          title: this.$t('order.ReBorrowOnThe3DayOfRepay'),
          align: 'left',
          dataIndex: 'reborrowCount3'
        },
        {
          title: this.$t('order.ReBorrowOnThe4DayOfRepay'),
          align: 'left',
          dataIndex: 'reborrowCount4'
        },
        {
          title: this.$t('order.ReBorrowOnThe5DayOfRepay'),
          align: 'left',
          dataIndex: 'reborrowCount5'
        },
        {
          title: this.$t('order.ReBorrowOnThe6DayOfRepay'),
          align: 'left',
          dataIndex: 'reborrowCount6'
        },
        {
          title: this.$t('order.ReBorrowOnThe7DayOfRepay'),
          align: 'left',
          dataIndex: 'reborrowCount7'
        },
        {
          title: this.$t('order.reborrowedPensTotalNum'),
          align: 'left',
          dataIndex: 'reborrowCount8'
        }
        ,
        {
          title: this.$t('order.FirstDayRefinancingRate'),
          align: 'left',
          dataIndex: 'rate1'
        },
        {
          title: this.$t('order.SevenDayRefinancingRate'),
          align: 'left',
          dataIndex: 'rate7'
        },
        {
          title: this.$t('order.TenDayRefinancingRate'),
          align: 'left',
          dataIndex: 'rate10'
        },
        {
          title: this.$t('order.fifteenDayRefinancingRate'),
          align: 'left',
          dataIndex: 'rate15'
        },
        {
          title: this.$t('order.ReLendingRate'),
          align: 'left',
          dataIndex: 'rate'
        }


      ]
    }
  },
  created() {
    this.getDict()
    this.loadData()
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || []
    })
    getApplist().then(res => {
      // this.appList = []
      // this.appInList = res.data || []
      // for (var i = 0; i < this.appInList.length; i++) {
      //   if (this.appInList[i].appssid != '') {
      //     this.appList.push(this.appInList[i])
      //   }
      // }

      this.appList = res.data || []
    })
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      reborrowCountForSubmit(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data.total
          this.dataSource = res.data || []

          for (var i = 0; i < this.dataSource.length; i++) {
            var dataIn = this.dataSource[i]
            // dataIn.rate = (dataIn.reborrowCount8 / dataIn.countSettleOrder).toFixed(2);
          }

        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { lendingTime } = this.queryParam
      const data = {
        ...this.queryParam,
        lendingTimeStart: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[0]) : undefined,
        lendingTimeEnd: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[1]) : undefined
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.lendingTime = undefined
      that.queryParam.serviceFee=null
      that.queryParam.appSsids = ''
      that.queryParam.settleType=''
      that.queryParam.deadlineConfigValue=''
      that.queryParam.receiptTimeFlag = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    downLoadData(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/order/countLoanDataWithDateExcel?lendingTimeStart=' + params.lendingTimeStart + '&lendingTimeEnd=' + params.lendingTimeEnd + '&custType=' + params.custType,
        fileName: 'countLoanDataWithDateExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
